import React from 'react';
import { Round as ArrowBack } from '@tamagoshi/icons/ArrowBack';
import { string, func } from 'prop-types';
import styles from './styles/index.module.scss';

const MenuGoBack = ({ label, onClick }) => {
  /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
  return (
    <li className={styles.goBackItem} onClick={onClick}>
      <ArrowBack className={styles.arrowBack} />
      {label}
    </li>
  );
};

MenuGoBack.propTypes = {
  label: string.isRequired,
  onClick: func.isRequired,
};

MenuGoBack.displayName = 'MenuGoBack';

export default MenuGoBack;
